import React, { useEffect, useState } from 'react'
import Footer from '../Header/Footer'
import Header from '../Header/Header'
import { FaEdit, FaShoppingCart, FaTrashAlt } from 'react-icons/fa';
import Config from '../Header/Config';
import { useLocation, useNavigate } from 'react-router-dom';

export default function Sale_update() {
  const [imeiNotFound, setImeiNotFound] = useState(false);
  //............set  todays date

  const today = new Date().toISOString().split("T")[0];
  //............Customer Details
  const [invoiceNumber, setInvoiceNumber] = useState("");
  const [date, setDate] = useState(today);
  const [customerName, setCustomerName] = useState("");
  const [mobileNumber, setMobileNumber] = useState("");
  const [address, setAddress] = useState("");

  //............Buy Back Details

  const [buyBackIemi, setBuyBacIemi] = useState("");
  const [buyBackModel, setBuyBackModel] = useState("");
  const [buyBackColor, setBuyBackColor] = useState("");
  const [buyBackPrice, setBuyBackPrice] = useState("");
  const [buyBackSalePrice, setBuyBackSalePrice] = useState(""); // Sale Price field

  //..............Brand Details

  const [modelName, setModelName] = useState("");
  const [imei, setImei] = useState("");
  const [mrp, setMrp] = useState("");
  const [brandDiscount, setBrandDiscount] = useState("");
  const [price, setPrice] = useState("");
  const [color, setColor] = useState("");
  const [accessories, setAccessories] = useState("Charger, Bill Box");

  //................Payment Details
  const [subTotal, setSubTotal] = useState(0);
  let [grantTotal, setGrantTotal] = useState(0);
  const [payableAmount, setPayableAmount] = useState("");
  const [payableAmount1, setPayableAmount1] = useState("");
  const [paymentMode, setPaymentMode] = useState("Cash Deposit");
  const [paymentMode1, setPaymentMode1] = useState("");
  let [balance, setBalance] = useState(0);
  const [buyBackTotal, setBuyBackTotal] = useState(0); // Track total Buy Back price



  const apiUrl = Config.apiUrl;
  const navigate = useNavigate();

  const capitalizeWords = (str) => {
    if (!str) return '';
    return str
      .toString()
      .split(/\s+/)
      .map((w) => (w.length > 0 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : ''))
      .join(' ');
  };

  const location = useLocation();

  const searchParams = new URLSearchParams(location.search);
  const invoice_Number = searchParams.get("invoice_no");

  const imeiParam = searchParams.get("id");
  const idParam = parseInt(imeiParam);

  const [selectedRow, setSelectedRow] = useState(null); // New state to store the selected row
  const [totalPurchasePrice, setTotalPurchasePrice] = useState(0); // New state for total purchase prices

  const handleBrandUpdate = async (row) => {
    const { id } = row;
    setSelectedRow(row);
    const queryParams = new URLSearchParams({
      invoice_no: invoice_Number,
      id: id, // Make sure to pass the correct 'id' value here
    });
    navigate(`/sale_update?${queryParams}`);
  };

  //................................[ Sales Details ]....................................................
  //........................................[ set data in brand details].........................................
  const [tableData, setTableData] = useState([]);
  const [buyBackItems, setBuyBackItems] = useState([]); // Store buy back items in array
  const [editIndex, setEditIndex] = useState(null); // Track which Brand Details item is being edited
  const [editBuyBackIndex, setEditBuyBackIndex] = useState(null); // Track which Buy Back item is being edited
  const [newItems, setNewItems] = useState([]); // Track newly added items (without id)
  const [updatedItems, setUpdatedItems] = useState([]); // Track updated items (with id)
  const [deletedItems, setDeletedItems] = useState([]); // Track deleted items (with id) for DB deletion
  const [newBuyBackItems, setNewBuyBackItems] = useState([]); // Track newly added buyback items
  const [updatedBuyBackItems, setUpdatedBuyBackItems] = useState([]); // Track updated buyback items
  const [deletedBuyBackItems, setDeletedBuyBackItems] = useState([]); // Track deleted buyback items
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_SalesInvoice/${invoice_Number}`);

        const result = await response.json();

        // New API response format: { sales_details, sales_items, brand_details }
        if (result.status === 'success') {
          const salesDetails = result.sales_details || {};
          const salesItems = result.sales_items || [];
          const brandDetails = result.brand_details || [];

          // Set customer and invoice details from sales_details
          setInvoiceNumber(salesDetails.invoice_no || "");
          setDate(salesDetails.date || today);
          setCustomerName(salesDetails.customer_name || "");
          setMobileNumber(salesDetails.mobile_no || "");
          setAddress(salesDetails.address || "");

          setPayableAmount(salesDetails.payable_amount || "");
          setPayableAmount1(salesDetails.payable_amount_2 || "");
          setGrantTotal(salesDetails.grand_total || 0);
          setPaymentMode(salesDetails.payment_mode || "Cash Deposit");
          setPaymentMode1(salesDetails.payment_mode_2 || "");
          setSubTotal(salesDetails.sub_total || 0);

          // Set sales items (regular items)
          setTableData(salesItems);

          // Set buyback items (brand_details)
          setBuyBackItems(brandDetails);

          // Calculate buyback total
          const bbTotal = brandDetails.reduce((sum, item) => {
            const priceValue = parseFloat(item.price?.toString().replace(/[,\s]/g, '')) || 0;
            return sum + priceValue;
          }, 0);
          setBuyBackTotal(bbTotal);

          // If idParam is provided, populate form for editing
          if (idParam && salesItems.length > 0) {
            const brandDetailsToEdit = salesItems.find((item) => item.id === idParam);
            if (brandDetailsToEdit) {
              const index = salesItems.findIndex((item) => item.id === idParam);
              setEditIndex(index);
              setModelName(brandDetailsToEdit.model_name || "");
              setColor(brandDetailsToEdit.color || "");
              setImei(brandDetailsToEdit.imei || "");
              setMrp(brandDetailsToEdit.mrp ? brandDetailsToEdit.mrp.toString() : "");
              setBrandDiscount(brandDetailsToEdit.discount ? brandDetailsToEdit.discount.toString() : "0");
              setPrice(brandDetailsToEdit.price ? brandDetailsToEdit.price.toString() : "");
              setAccessories(brandDetailsToEdit.accessories || "Charger, Bill Box");
            }
          }

          console.log("Sales Items:", salesItems);
          console.log("Buyback Items:", brandDetails);
        } else {
          console.error('API returned error:', result.message);
        }





      } catch (error) {
        console.error(error);
      }
    };

    if (invoice_Number) {
      fetchData();
    }
  }, [invoice_Number, idParam, apiUrl, today]);

  // ..........................[ Calculate Sub Total (MRP sum) and Grant Total (Price sum) from tableData ].............................
  useEffect(() => {
    if (tableData && tableData.length > 0) {
      // Calculate Sub Total = MRP sum
      const mrpTotal = tableData.reduce((sum, item) => {
        const mrpValue = parseFloat(item.mrp?.toString().replace(/[,\s]/g, '')) || 0;
        return sum + mrpValue;
      }, 0);
      setSubTotal(mrpTotal);

      // Calculate Grant Total = Price sum - Buy Back total
      // Allow both positive and negative values
      const priceTotal = tableData.reduce((sum, item) => {
        const priceValue = parseFloat(item.price?.toString().replace(/[,\s]/g, '')) || 0;
        return sum + priceValue;
      }, 0);
      const finalGrantTotal = priceTotal - buyBackTotal;
      setGrantTotal(finalGrantTotal); // Removed clamping to 0
    } else {
      setSubTotal(0);
      const finalGrantTotal = 0 - buyBackTotal;
      setGrantTotal(finalGrantTotal); // Removed clamping to 0
    }
  }, [tableData, buyBackTotal]);



  //...................................................[ Update brand Items].....................................................................................

  // Handle Edit for Brand Details
  const handleEdit = (index) => {
    const item = tableData[index];
    if (item) {
      setEditIndex(index);
      setModelName(item.model_name || "");
      setColor(item.color || "");
      setImei(item.imei || "");
      setMrp(item.mrp ? item.mrp.toString() : "");
      setBrandDiscount(item.discount ? item.discount.toString() : "0");
      setPrice(item.price ? item.price.toString() : "");
      setAccessories(item.accessories || "Charger, Bill Box");
      alert("Editing item. Make changes and click Update to save.");
    }
  };

  // Cancel Edit for Brand Details
  const handleCancelEdit = () => {
    setEditIndex(null);
    setModelName("");
    setColor("");
    setImei("");
    setMrp("");
    setBrandDiscount("");
    setPrice("");
    setAccessories("Charger, Bill Box");
  };

  const updateBrandDetails = () => {
    const item = {
      model_name: modelName,
      color: color,
      imei: imei,
      mrp: mrp,
      discount: brandDiscount || "0",
      price: price,
      accessories: accessories,
    };

    if (editIndex !== null) {
      // Update existing item in array
      const updatedTableData = [...tableData];
      const existingItem = updatedTableData[editIndex];
      item.id = existingItem.id; // Preserve existing ID
      item.invoice_no = invoice_Number; // Preserve invoice_no
      updatedTableData[editIndex] = item;
      setTableData(updatedTableData);

      // Track for batch update
      setUpdatedItems((prev) => {
        const filtered = prev.filter((i) => i.id !== item.id);
        return [...filtered, item];
      });
      
      // Remove from newItems if it was there
      setNewItems((prev) => prev.filter((i) => 
        i.imei !== item.imei || i.model_name !== item.model_name
      ));

      alert("Item updated in list. Click Update button to save changes.");
      setEditIndex(null);
    } else {
      // Add new item to the list (no ID yet)
      const newItem = { ...item, invoice_no: invoice_Number };
      setTableData((prev) => [...prev, newItem]);
      setNewItems((prev) => [...prev, newItem]);
      alert("Item added to list. Click Update button to save changes.");
    }

    // Clear form fields
    setModelName("");
    setColor("");
    setImei("");
    setMrp("");
    setBrandDiscount("");
    setPrice("");
    setAccessories("Charger, Bill Box");
  };
  //...........................[ Update Sale Details ].........................................................
  const [showBrandListTable, setShowBrandListTable] = useState(true); // Default: show the table
  const [updatedDetails, setUpdatedDetails] = useState([])
  const updateSaleDetails = async () => {
    const item = {
      date: date,
      customer_name: customerName,
      mobile_no: mobileNumber,
      address: address,
      sub_total: subTotal,
      grand_total: grantTotal,
      payable_amount: payableAmount || 0,
      payment_mode: paymentMode,
      payable_amount_2: payableAmount1 || 0,
      payment_mode_2: paymentMode1 || ""
    };

    try {
      // Step 1: Update Sales Details
      const result = await fetch(`${apiUrl}/update_salesDetails/${invoice_Number}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
        body: JSON.stringify(item),
      });

      if (!result.ok) {
        let errorMessage = "Failed to update Sales Details";
        try {
          const errorData = await result.json();
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.data && errorData.data.message) {
            errorMessage = errorData.data.message;
          }
        } catch (parseError) {
          errorMessage = `Error ${result.status}: ${result.statusText || "Failed to update Sales Details"}`;
        }
        alert(errorMessage);
        console.error("API Error:", errorMessage);
        return;
      }

      // Step 2: Update existing items
      if (updatedItems && updatedItems.length > 0) {
        console.log(`Updating ${updatedItems.length} items...`);
        const updatePromises = updatedItems.map((item) => {
          console.log(`Updating item:`, item);
          return fetch(`${apiUrl}/update_salesItems/${item.id}/${invoice_Number}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(item),
          });
        });

        const updateResults = await Promise.all(updatePromises);
        const failedResults = updateResults.filter((result) => !result.ok);
        
        if (failedResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to update item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to update item"}`);
            }
          }
          alert(`Failed to update some items:\n${errorMessages.join("\n")}`);
          console.error("Update Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully updated ${updatedItems.length} items`);
      }

      // Step 3: Add new items
      if (newItems && newItems.length > 0) {
        console.log(`Adding ${newItems.length} new items...`);
        const addPromises = newItems.map((item) => {
          console.log(`Adding new item:`, item);
          return fetch(`${apiUrl}/sales_items`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(item),
          });
        });

        const addResults = await Promise.all(addPromises);
        const failedAddResults = addResults.filter((result) => !result.ok);
        
        if (failedAddResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedAddResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to add item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to add item"}`);
            }
          }
          alert(`Failed to add some new items:\n${errorMessages.join("\n")}`);
          console.error("Add Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully added ${newItems.length} new items`);
      }

      // Step 4: Delete items that were removed
      if (deletedItems && deletedItems.length > 0) {
        console.log(`Deleting ${deletedItems.length} items...`);
        const deletePromises = deletedItems.map((id) => {
          console.log(`Deleting item with id ${id}`);
          return fetch(`${apiUrl}/delete_salesItems/${id}`, {
            method: "DELETE",
          });
        });

        const deleteResults = await Promise.all(deletePromises);
        const failedDeleteResults = deleteResults.filter((result) => !result.ok);
        
        if (failedDeleteResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedDeleteResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to delete item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to delete item"}`);
            }
          }
          alert(`Failed to delete some items:\n${errorMessages.join("\n")}`);
          console.error("Delete Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully deleted ${deletedItems.length} items`);
      }

      // Step 5: Update buyback items
      if (updatedBuyBackItems && updatedBuyBackItems.length > 0) {
        console.log(`Updating ${updatedBuyBackItems.length} buyback items...`);
        const updatePromises = updatedBuyBackItems.map((item) => {
          console.log(`Updating buyback item with id ${item.id}:`, item);
          // Map price to purchase_price and sales_price to sale_price for API
          const apiItem = {
            ...item,
            purchase_price: item.price || item.purchase_price || "",
            sale_price: item.sales_price || item.sale_price || "",
          };
          // Remove the old field names if they exist
          delete apiItem.price;
          delete apiItem.sales_price;
          return fetch(`${apiUrl}/update_returnBrand/${item.id}/${invoice_Number}`, {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(apiItem),
          });
        });

        const updateResults = await Promise.all(updatePromises);
        const failedResults = updateResults.filter((result) => !result.ok);
        
        if (failedResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to update buyback item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to update buyback item"}`);
            }
          }
          alert(`Failed to update some buyback items:\n${errorMessages.join("\n")}`);
          console.error("Update BuyBack Items Error:", errorMessages);
          return;
        }
        console.log(`Successfully updated ${updatedBuyBackItems.length} buyback items`);
      }

      // Step 6: Add new buyback items
      if (newBuyBackItems && newBuyBackItems.length > 0) {
        console.log(`Adding ${newBuyBackItems.length} new buyback items...`);
        const addPromises = newBuyBackItems.map((item) => {
          return fetch(`${apiUrl}/returnBrand`, {
            method: "POST",
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
            },
            body: JSON.stringify(item),
          });
        });

        const addResults = await Promise.all(addPromises);
        const failedAddResults = addResults.filter((result) => !result.ok);
        
        if (failedAddResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedAddResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to add buyback item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to add buyback item"}`);
            }
          }
          alert(`Failed to add some buyback items:\n${errorMessages.join("\n")}`);
          console.error("Add BuyBack Items Error:", errorMessages);
          return;
        }
      }

      // Step 7: Delete buyback items
      if (deletedBuyBackItems && deletedBuyBackItems.length > 0) {
        console.log(`Deleting ${deletedBuyBackItems.length} buyback items...`);
        const deletePromises = deletedBuyBackItems.map((id) => {
          return fetch(`${apiUrl}/delete_returnBrand/${id}`, {
            method: "DELETE",
          });
        });

        const deleteResults = await Promise.all(deletePromises);
        const failedDeleteResults = deleteResults.filter((result) => !result.ok);
        
        if (failedDeleteResults.length > 0) {
          let errorMessages = [];
          for (const failedResult of failedDeleteResults) {
            try {
              const errorData = await failedResult.json();
              errorMessages.push(errorData.message || errorData.error || "Failed to delete buyback item");
            } catch (parseError) {
              errorMessages.push(`Error ${failedResult.status}: ${failedResult.statusText || "Failed to delete buyback item"}`);
            }
          }
          alert(`Failed to delete some buyback items:\n${errorMessages.join("\n")}`);
          console.error("Delete BuyBack Items Error:", errorMessages);
          return;
        }
      }

      // All updates successful
      alert("Sales Details updated successfully");
      
      // Clear states
      setNewItems([]);
      setUpdatedItems([]);
      setDeletedItems([]);
      setNewBuyBackItems([]);
      setUpdatedBuyBackItems([]);
      setDeletedBuyBackItems([]);
      setEditIndex(null);
      setEditBuyBackIndex(null);

      // Navigate back to previous page
      setTimeout(() => {
        navigate(-1);
      }, 500); // Small delay to show success message

    } catch (error) {
      console.error("Network/Request Error:", error);
      let errorMessage = "Failed to update Sales Details";
      
      if (error.message) {
        errorMessage = error.message;
      } else if (error.name === "TypeError" && error.message.includes("fetch")) {
        errorMessage = "Network Error: Unable to connect to server. Please check your internet connection or CORS settings.";
      } else if (error.name === "TypeError") {
        errorMessage = `Network Error: ${error.message}`;
      }
      
      alert(errorMessage);
    }
  };

  //........................................................................................
  
  //.........................................[ delete salesDetails ].......................................
  
  const deleteSalesDetails = async () => {
    const confirmDelete = window.confirm(
      "Are you sure you want to delete this Sales Details record? This action cannot be undone."
    );

    if (!confirmDelete) {
      return;
    }

    try {
      const result = await fetch(`${apiUrl}/delete_salesDetails/${invoice_Number}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      });

      if (!result.ok) {
        let errorMessage = "Failed to delete Sales Details";
        try {
          const errorData = await result.json();
          if (errorData.message) {
            errorMessage = errorData.message;
          } else if (errorData.error) {
            errorMessage = errorData.error;
          } else if (errorData.data && errorData.data.message) {
            errorMessage = errorData.data.message;
          }
        } catch (parseError) {
          errorMessage = `Error ${result.status}: ${result.statusText || "Failed to delete Sales Details"}`;
        }
        alert(errorMessage);
        console.error("API Error:", errorMessage);
        return;
      }

      const responseData = await result.json();
      console.log("Delete Sales Details Response:", responseData);

      alert("Sales Details deleted successfully");
      
      // Navigate back to previous page
      setTimeout(() => {
        navigate(-1);
      }, 500);
    } catch (error) {
      console.error("Network/Request Error:", error);
      let errorMessage = "Failed to delete Sales Details";
      
      if (error.message) {
        errorMessage = error.message;
      } else if (error.name === "TypeError" && error.message.includes("fetch")) {
        errorMessage = "Network Error: Unable to connect to server. Please check your internet connection or CORS settings.";
      } else if (error.name === "TypeError") {
        errorMessage = `Network Error: ${error.message}`;
      }
      
      alert(errorMessage);
    }
  };

  //........................................................................................

  // Edit Buy Back item
  const handleEditBuyBack = (index) => {
    const item = buyBackItems[index];
    if (item) {
      setEditBuyBackIndex(index);
      setBuyBackModel(item.model_name || "");
      setBuyBacIemi(item.imei || "");
      setBuyBackColor(item.color || "");
      setBuyBackPrice(item.price ? item.price.toString() : "");
      setBuyBackSalePrice(item.sales_price ? item.sales_price.toString() : "");
      alert("Editing buy back item. Make changes and click Buy Back to update.");
    }
  };

  // Cancel Edit for Buy Back
  const handleCancelEditBuyBack = () => {
    setEditBuyBackIndex(null);
    setBuyBackModel("");
    setBuyBacIemi("");
    setBuyBackColor("");
    setBuyBackPrice("");
    setBuyBackSalePrice("");
  };

  // Delete Buy Back item from array
  const handleDeleteBuyBack = (index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this buy back item from the list?"
    );

    if (confirmDelete) {
      const itemToDelete = buyBackItems[index];
      const deletedPrice = parseFloat(itemToDelete?.price?.toString().replace(/[,\s]/g, '')) || 0;
      
      // Remove from array
      setBuyBackItems((preData) => preData.filter((_, i) => i !== index));
      
      // Update buy back total
      setBuyBackTotal((prevTotal) => Math.max(0, prevTotal - deletedPrice));
      
      // If item has id, track for deletion from DB
      if (itemToDelete.id) {
        setDeletedBuyBackItems((prev) => [...prev, itemToDelete.id]);
        // Remove from updatedBuyBackItems if it was there
        setUpdatedBuyBackItems((prev) => prev.filter((item) => item.id !== itemToDelete.id));
      } else {
        // Remove from newBuyBackItems if it was there (no id means it's a new item)
        setNewBuyBackItems((prev) => prev.filter((item) => 
          item.imei !== itemToDelete.imei || 
          item.model_name !== itemToDelete.model_name
        ));
      }

      alert("Buy back item removed from list. Click Update button to save changes.");
    }
  };

  // Add Buy Back Details
  const addBuyBackDetails = () => {
    const item = {
      invoice_no: invoice_Number,
      model_name: buyBackModel,
      imei: buyBackIemi,
      color: buyBackColor,
      price: buyBackPrice,
      sales_price: buyBackSalePrice,
    };

    if (editBuyBackIndex !== null) {
      // Update existing item in array
      const oldItem = buyBackItems[editBuyBackIndex];
      const oldPrice = parseFloat(oldItem?.price?.toString().replace(/[,\s]/g, '')) || 0;
      const newPrice = parseFloat(buyBackPrice.replace(/[,\s]/g, '')) || 0;
      
      // Update in array
      const updatedBuyBackItems = [...buyBackItems];
      item.id = oldItem.id; // Preserve existing ID
      updatedBuyBackItems[editBuyBackIndex] = item;
      setBuyBackItems(updatedBuyBackItems);
      
      // Update buy back total (subtract old, add new)
      setBuyBackTotal((prevTotal) => prevTotal - oldPrice + newPrice);
      
      // Track for batch update
      setUpdatedBuyBackItems((prev) => {
        const filtered = prev.filter((i) => i.id !== item.id);
        return [...filtered, item];
      });
      
      // Remove from newBuyBackItems if it was there
      setNewBuyBackItems((prev) => prev.filter((i) => 
        i.imei !== item.imei || i.model_name !== item.model_name
      ));

      alert("Buy Back item updated in list. Click Update button to save changes.");
      setEditBuyBackIndex(null);
    } else {
      // Add new item to the list (no ID yet)
      setBuyBackItems((prevItems) => [...prevItems, item]);
      setNewBuyBackItems((prev) => [...prev, item]);
      
      // Calculate and update Buy Back total
      const bbprice = parseFloat(buyBackPrice.replace(/[,\s]/g, '')) || 0;
      setBuyBackTotal((prevTotal) => prevTotal + bbprice);
      
      alert("Buy Back item added to list. Click Update button to save changes.");
    }

    // Clear form fields
    setBuyBackModel("");
    setBuyBacIemi("");
    setBuyBackColor("");
    setBuyBackPrice("");
    setBuyBackSalePrice("");
  };

  // Delete Record - Remove from array (will be deleted from DB on final submit if has id)
  const handleDelete = (id, index) => {
    const confirmDelete = window.confirm(
      "Are you sure you want to remove this item from the list?"
    );

    if (confirmDelete) {
      const itemToDelete = tableData[index];
      
      // Remove from array
      setTableData((preData) => preData.filter((_, i) => i !== index));
      
      // If item has id, track for deletion from DB
      if (id) {
        setDeletedItems((prev) => [...prev, id]);
        // Remove from updatedItems if it was there
        setUpdatedItems((prev) => prev.filter((item) => item.id !== id));
      } else {
        // Remove from newItems if it was there (no id means it's a new item)
        setNewItems((prev) => prev.filter((item) => 
          item.imei !== itemToDelete.imei || 
          item.model_name !== itemToDelete.model_name
        ));
      }

      alert("Item removed from list. Click Update button to save changes.");
    }
  };
  //...................................


  const [modelList, setModelList] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}/get_all_models`);
        const data = await response.json();
        setModelList(data.data);
        console.log(data);
      } catch (error) {
        console.error(error);
      }
    };

    fetchData();
  }, []);


  return (
    <>
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />

          <div className="layout-page">
            <div className="content-wrapper">
              <div className="container-xxl flex-grow-1 container-p-y">
                <h4 className="fw-bold py-3 mb-4">Sale Details</h4>

                <div className="card mb-4">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="mb-0 heading-heighlight">Customer Details</h5>
                  </div>
                  <div className="card-body">
                    <div className="row">
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-fullname"
                        >
                          Invoice Number
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="basic-default-fullname"
                          placeholder="Enter Invoice Number"
                          value={invoiceNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '');
                            setInvoiceNumber(value);
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-company"
                        >
                          Date
                        </label>
                        <input
                          type="date"
                          className="form-control"
                          id="basic-default-fullname"
                          placeholder="Enter date"
                          value={date}
                          onChange={(e) => setDate(e.target.value)}
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-email"
                        >
                          Customer Name
                        </label>
                        <div className="input-group input-group-merge">
                          <input
                            type="text"
                            id="basic-default-email"
                            className="form-control"
                            placeholder="Enter Customer Name"
                            aria-label="john.doe"
                            aria-describedby="basic-default-email2"
                            value={customerName}
                            onChange={(e) => {
                              const v = capitalizeWords(e.target.value);
                              setCustomerName(v);
                            }}
                          />
                        </div>
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Mobile Number
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Mobile Number"
                          maxLength={10}
                          value={mobileNumber}
                          onChange={(e) => {
                            const value = e.target.value.replace(/\D/g, '').slice(0, 10);
                            setMobileNumber(value);
                          }}
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Address
                        </label>
                        <textarea
                          id="basic-default-message"
                          className="form-control"
                          placeholder="Enter Address"
                          defaultValue={""}
                          rows={1}
                          value={address}
                          onChange={(e) => setAddress(e.target.value)}
                        />
                      </div>
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Brand Details</h5>

                      <div className="col-md-6 mb-3">
                        <div className="row">
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="basic-default-company">
                              Model Name
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              list="browsers"
                              name="browser"
                              id="browser"
                              placeholder="Enter Model Name"
                              value={modelName}
                              onChange={(e) => setModelName(e.target.value)}
                            />
                            <datalist id="browsers">
                              {modelList.map((model, index) => (
                                <option key={index} value={model.model_name} />
                              ))}
                            </datalist>
                          </div>
                          <div className="col-md-6 mb-3">
                            <label className="form-label" htmlFor="basic-default-company">
                              Color
                            </label>
                            <input
                              type="text"
                              className="form-control"
                              id="basic-default-company"
                              placeholder="Enter Color"
                              value={color}
                              onChange={(e) => {
                                const v = capitalizeWords(e.target.value);
                                setColor(v);
                              }}
                            />
                          </div>


                        </div>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          IMEI
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter IMEI"
                          value={imei}
                          style={{ textTransform: 'uppercase' }}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setImei(value);
                          }}
                        />
                        {imeiNotFound && <span style={{ color: "red" }}>IMEI not found</span>}
                      </div>
                      <div className="col-md-12 mb-3">
                        <div className="row">
                          <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                              htmlFor="basic-default-mrp"
                            >
                              MRP
                            </label>
                            <input
                              type="text"
                              id="basic-default-mrp"
                              className="form-control phone-mask"
                              placeholder="Enter MRP"
                              value={mrp}
                              onChange={(e) => {
                                let value = e.target.value.replace(/[^\d.,\s]/g, '');
                                setMrp(value);
                                // Auto-calculate price based on MRP and Discount
                                const discountValue = brandDiscount ? parseFloat(brandDiscount.replace(/[,\s]/g, '')) : 0;
                                const mrpValue = parseFloat(value.replace(/[,\s]/g, ''));
                                if (!isNaN(mrpValue) && mrpValue > 0) {
                                  const calculatedPrice = mrpValue - discountValue;
                                  setPrice(calculatedPrice > 0 ? calculatedPrice.toString() : "");
                                }
                              }}
                            />
                          </div>

                          <div className="col-md-3 mb-3">
                            <label
                              className="form-label"
                              htmlFor="basic-default-brand-discount"
                            >
                              Discount
                            </label>
                            <input
                              type="text"
                              id="basic-default-brand-discount"
                              className="form-control phone-mask"
                              placeholder="Enter Discount"
                              value={brandDiscount}
                              onChange={(e) => {
                                let value = e.target.value.replace(/[^\d.,\s]/g, '');
                                setBrandDiscount(value);
                                // Auto-calculate price based on MRP and Discount
                                const mrpValue = mrp ? parseFloat(mrp.replace(/[,\s]/g, '')) : 0;
                                const discountValue = value ? parseFloat(value.replace(/[,\s]/g, '')) : 0;
                                if (!isNaN(mrpValue) && mrpValue > 0) {
                                  const calculatedPrice = mrpValue - discountValue;
                                  setPrice(calculatedPrice > 0 ? calculatedPrice.toString() : "");
                                }
                              }}
                            />
                          </div>

                          <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                              htmlFor="basic-default-price"
                        >
                          Price
                        </label>
                        <input
                          type="text"
                              id="basic-default-price"
                          className="form-control phone-mask"
                          placeholder="Enter Price"
                          value={price}
                          onChange={(e) => {
                                let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPrice(value);
                          }}
                        />
                      </div>

                          <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                              htmlFor="basic-default-accessories"
                        >
                          Accessories
                        </label>
                            <input
                              type="text"
                              id="basic-default-accessories"
                          className="form-control"
                              placeholder="Enter Accessories"
                          value={accessories}
                          onChange={(e) => setAccessories(e.target.value)}
                        />
                          </div>
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="col-12 d-flex justify-content-end">
                          {editIndex !== null && (
                            <button
                              type="button"
                              className="btn btn-secondary"
                              style={{ marginLeft: "5px", marginRight: "5px" }}
                              onClick={handleCancelEdit}
                            >
                              Cancel
                            </button>
                          )}
                          <button
                            type="button"
                            className="btn btn-primary"
                            style={{ marginLeft: "5px", marginRight: "5px" }}
                            onClick={() => updateBrandDetails()}
                            disabled={editIndex === null}
                          >
                            Update
                          </button>
                        </div>
                        {showBrandListTable && (
                          <div className="card mt-3">
                            <h5 className="card-header heading-heighlight">Brand List</h5>

                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr className="text-nowrap">
                                    <th>SN</th>
                                    <th>Model Name</th>
                                    <th>Color</th>
                                    <th>IMEI</th>
                                    <th>MRP</th>
                                    <th>Discount</th>
                                    <th>Price</th>
                                    <th>Accessories</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(tableData) &&
                                    tableData.map((row, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.model_name}</td>
                                        <td>{row.color}</td>
                                        <td>{row.imei}</td>
                                        <td>{row.mrp || "-"}</td>
                                        <td>{row.discount || "-"}</td>
                                        <td>{row.price}</td>
                                        <td>{row.accessories}</td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm me-1"
                                            onClick={() => handleEdit(index)}
                                            style={{ marginRight: "5px" }}
                                            title="Edit"
                                          >
                                            <FaEdit />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleDelete(row.id, index)}
                                            title="Delete"
                                          >
                                            <FaTrashAlt />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>

                        )}
                      </div>
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Buy Back Details</h5>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-company"
                        >
                          Model Name
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Model Name"
                          value={buyBackModel}
                          onChange={(e) => setBuyBackModel(e.target.value)}
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-buyback-color"
                        >
                          Color
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          id="basic-default-buyback-color"
                          list="rainbow-colors"
                          placeholder="Enter Color"
                          value={buyBackColor}
                          onChange={(e) => {
                            const v = capitalizeWords(e.target.value);
                            setBuyBackColor(v);
                          }}
                        />
                        <datalist id="rainbow-colors">
                          <option value="Black" />
                          <option value="White" />
                          <option value="Blue" />
                          <option value="Yellow" />
                          <option value="Coral" />
                          <option value="RED" />
                          <option value="Purple" />
                          <option value="Green" />
                          <option value="Starlight" />
                          <option value="Midnight" />
                          <option value="Pink" />
                          <option value="Teal" />
                          <option value="Ultramarine" />
                          <option value="Mist Blue" />
                          <option value="Sage" />
                          <option value="Lavender" />
                          <option value="Silver" />
                          <option value="Space Gray" />
                          <option value="Gold" />
                          <option value="Midnight Green" />
                          <option value="Graphite" />
                          <option value="Pacific Blue" />
                          <option value="Sierra Blue" />
                          <option value="Alpine Green" />
                          <option value="Space Black" />
                          <option value="Deep Purple" />
                          <option value="Black Titanium" />
                          <option value="White Titanium" />
                          <option value="Blue Titanium" />
                          <option value="Natural Titanium" />
                          <option value="Desert Titanium" />
                          <option value="Cosmic Orange" />
                          <option value="Deep Blue" />
                        </datalist>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          IMEI
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter IMEI"
                          value={buyBackIemi}
                          style={{ textTransform: 'uppercase' }}
                          onChange={(e) => {
                            const value = e.target.value.toUpperCase();
                            setBuyBacIemi(value);
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Price
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Enter Price"
                          value={buyBackPrice}
                          onChange={(e) => {
                            const value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setBuyBackPrice(value);
                          }}
                        />
                      </div>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-buyback-sale-price"
                        >
                          Sale Price
                        </label>
                        <input
                          type="text"
                          id="basic-default-buyback-sale-price"
                          className="form-control phone-mask"
                          placeholder="Enter Sale Price"
                          value={buyBackSalePrice}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setBuyBackSalePrice(value);
                          }}
                        />
                      </div>
                      <div className="col-12 d-flex justify-content-end mt-3">
                        {editBuyBackIndex !== null && (
                          <button
                            type="button"
                            className="btn btn-secondary"
                            style={{ marginLeft: "5px", marginRight: "5px" }}
                            onClick={handleCancelEditBuyBack}
                          >
                            Cancel
                          </button>
                        )}
                        <button
                          type="button"
                          className="btn btn-primary"
                          style={{ marginLeft: "5px", marginRight: "5px" }}
                          onClick={addBuyBackDetails}
                        >
                          {editBuyBackIndex !== null ? "Update" : "Buy Back"}
                        </button>
                      </div>
                      {buyBackItems.length > 0 && (
                        <div className="col-12 mt-3">
                          <div className="card">
                            <h5 className="card-header heading-heighlight">Buy Back List</h5>
                            <div className="table-responsive text-nowrap">
                              <table className="table">
                                <thead>
                                  <tr className="text-nowrap">
                                    <th>SN</th>
                                    <th>Model Name</th>
                                    <th>IMEI</th>
                                    <th>Color</th>
                                    <th>Price</th>
                                    <th>Sale Price</th>
                                    <th>Action</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  {Array.isArray(buyBackItems) &&
                                    buyBackItems.map((row, index) => (
                                      <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{row.model_name}</td>
                                        <td>{row.imei}</td>
                                        <td>{row.color}</td>
                                        <td>{row.price}</td>
                                        <td>{row.sales_price || "-"}</td>
                                        <td>
                                          <button
                                            type="button"
                                            className="btn btn-primary btn-sm me-1"
                                            onClick={() => handleEditBuyBack(index)}
                                            style={{ marginRight: "5px" }}
                                            title="Edit"
                                          >
                                            <FaEdit />
                                          </button>
                                          <button
                                            type="button"
                                            className="btn btn-danger btn-sm"
                                            onClick={() => handleDeleteBuyBack(index)}
                                            title="Delete"
                                          >
                                            <FaTrashAlt />
                                          </button>
                                        </td>
                                      </tr>
                                    ))}
                                </tbody>
                              </table>
                            </div>
                          </div>
                        </div>
                      )}
                      <hr className="mb-3 mt-3" />
                      <h5 className="mb-4 heading-heighlight">Payment Details</h5>
                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-company"
                        >
                          Sub Total
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Sub Total (MRP Sum)"
                          value={subTotal}
                          readOnly
                        />
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Grant Total
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Grant Total (Price Sum)"
                          value={grantTotal}
                          readOnly
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-cash-amount"
                        >
                          Cash Amount <small className="text-muted">(Optional)</small>
                        </label>
                        <input
                          type="text"
                          id="basic-default-cash-amount"
                          className="form-control phone-mask"
                          placeholder="Enter Cash Amount"
                          value={payableAmount}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPayableAmount(value);
                          }}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-payment-mode"
                        >
                          Payment Mode
                        </label>
                        <input
                          id="basic-default-payment-mode"
                          className="form-control"
                          placeholder="Cash Deposit"
                          rows={1}
                          value={paymentMode}
                          onChange={(e) => setPaymentMode(e.target.value)}
                          readOnly
                        />
                      </div>

                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-online-amount"
                        >
                          Online Amount <small className="text-muted">(Optional)</small>
                        </label>
                        <input
                          type="text"
                          id="basic-default-online-amount"
                          className="form-control phone-mask"
                          placeholder="Enter Online Amount"
                          value={payableAmount1}
                          onChange={(e) => {
                            let value = e.target.value.replace(/[^\d.,\s]/g, '');
                            setPayableAmount1(value);
                          }}
                        />
                      </div>
                      <div className="col-md-3 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-payment-mode-2"
                        >
                          Payment Mode <small className="text-muted">(Required if Online Amount entered)</small>
                        </label>
                        <select
                          className="form-select"
                          id="basic-default-payment-mode-2"
                          value={paymentMode1}
                          onChange={(e) => {
                            const newPaymentMode1 = e.target.value;
                            setPaymentMode1(newPaymentMode1);
                          }}
                        >
                          <option value="" disabled>
                            Select Payment Mode
                          </option>
                          <option value="Net Banking">Net Banking</option>
                          <option value="Paytm">Paytm</option>
                          <option value="Phone Pay">Phone Pay</option>
                          <option value="Google Pay">Google Pay</option>
                        </select>
                      </div>

                      <div className="col-md-6 mb-3">
                        <label
                          className="form-label"
                          htmlFor="basic-default-phone"
                        >
                          Balance Amount
                        </label>
                        <input
                          type="text"
                          id="basic-default-phone"
                          className="form-control phone-mask"
                          placeholder="Balance Amount"
                          value={balance = Number(grantTotal) - Number(payableAmount || 0) - Number(payableAmount1 || 0)}
                          readOnly
                        />
                      </div>

                      <div className="col-12 d-flex justify-content-end">
                        {tableData.length === 0 ? (
                          <button
                            type="button"
                            className="btn btn-danger"
                            style={{ marginLeft: '5px', marginRight: '5px' }}
                            onClick={deleteSalesDetails}
                          >
                            Delete Sale
                          </button>
                        ) : (
                          <button
                            type="submit"
                            className="btn btn-primary"
                            style={{ marginLeft: "5px", marginRight: "5px" }}
                            onClick={() => updateSaleDetails()}
                          >
                            Update
                          </button>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <Footer />

              <div className="content-backdrop fade" />
            </div>
          </div>
        </div>

        <div className="layout-overlay layout-menu-toggle" />
      </div>
    </>
  )
}
